enum ENotificationType {
  ERROR_ALERT = 'errorAlert',
  ERROR_POPUP = 'errorPopup',
  INFO_ALERT = 'infoAlert',
  INFO_POPUP = 'infoPopup',
}

export default ENotificationType;
